// test947
(947 && 0);
